module.exports = __webpack_public_path__ + "static/skinHealth-c21f15d11c56a1256c91d2f48f94f52b.png";